import { IntegrationNames } from 'common/constants/integrations';

export enum MotivationOptionValue {
  Feedback = 'feedback',
  Roadmap = 'prioritizeRoadmap',
  Announcements = 'productAnnouncements',
}

export enum CollectFeedbackOptionValue {
  Autopilot = 'autopilotFeedback',
  Behalf = 'behalfFeedback',
  Direct = 'directFeedback',
  Import = 'importFeedback',
}

export const SourcesOptionValue = {
  Intercom: IntegrationNames.intercom,
  HelpScout: IntegrationNames.helpscout,
  Zendesk: IntegrationNames.zendesk,
  Zoom: IntegrationNames.zoom,
  Gong: IntegrationNames.gong,
} as const;

export const IntegrationOptionValue = {
  Hubspot: IntegrationNames.hubspot,
  Salesforce: IntegrationNames.salesforce,
  Slack: IntegrationNames.slack,
  MicrosoftTeams: IntegrationNames.microsoftTeams,
  Discord: IntegrationNames.discord,
  Jira: IntegrationNames.jira,
  Clickup: IntegrationNames.clickup,
  Linear: IntegrationNames.linear,
  Asana: IntegrationNames.asana,
  Github: IntegrationNames.gitHub,
  AzureDevOps: IntegrationNames.azureDevops,
} as const;

export const SyncIntegrationOptionValue = {
  Sdk: 'sdk',
  Segment: IntegrationNames.segment,
  Salesforce: IntegrationNames.salesforce,
  Hubspot: IntegrationNames.hubspot,
} as const;

export const ToolOptionValue = {
  Intercom: SourcesOptionValue.Intercom,
  HelpScout: SourcesOptionValue.HelpScout,
  Hubspot: IntegrationOptionValue.Hubspot,
  Salesforce: IntegrationOptionValue.Salesforce,
  Zendesk: SourcesOptionValue.Zendesk,
  Slack: IntegrationOptionValue.Slack,
  Zoom: SourcesOptionValue.Zoom,
  Gong: SourcesOptionValue.Gong,
  MicrosoftTeams: IntegrationOptionValue.MicrosoftTeams,
  Discord: IntegrationOptionValue.Discord,
  Jira: IntegrationOptionValue.Jira,
  Clickup: IntegrationOptionValue.Clickup,
  Linear: IntegrationOptionValue.Linear,
  Asana: IntegrationOptionValue.Asana,
  Github: IntegrationOptionValue.Github,
  AzureDevOps: IntegrationOptionValue.AzureDevOps,
} as const;

export enum TeamOptionValue {
  Leadership = 'leadership',
  ProductManagers = 'product_managers',
  ProductOwners = 'product_owners',
  Sales = 'sales',
  CustomerSuccess = 'customer_success',
  CustomerSupport = 'customer_support',
  Engineering = 'engineering',
  Design = 'design',
  Operations = 'operations',
  Marketing = 'marketing',
  Other = 'other',
}

export const CompanySizeValue = {
  One: '1',
  TwoToTen: '2-10',
  ElevenToFifty: '11-50',
  FiftyOneToFiveHundred: '51-500',
  FiveHundredOneToOneThousand: '501-1000',
  OneThousandOneToFiveThousand: '1001-5000',
  FiveThousandOnePlus: '5001+',
};
